module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('strong', [_vm._v("Lieutenant Vincent of The Erie Regiment: January to August 1861")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“I stray by the brookside alone, Where oft we have wander’d before,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("And weep for my lov’d one, my own, My Willie has gone to the war!")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Willie has gone to the war, Willie, Willie my lov’d one my own;")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Willie has gone to the war, Willie, Willie my lov’d one is gone!”")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-r"
  }, [_c('em', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONE TO")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")])]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHEN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLINS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTER AND")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EORGE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOPER")]), _vm._v(", 1862"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn1",
      "id": "rch2fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The so-called “Secession Winter” of 1860–61 saw seven states secede from the United States. They organized themselves into the Confederate States of America for the express purposes of protecting the Southern “peculiar institution” of slavery in the wake of the election of Abraham Lincoln. The nascent Confederacy came into being on February 8, 1861. The next day, it elected for its president Jefferson Davis of Mississippi. Four more states would follow them into secession within a few months."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn2",
      "id": "rch2fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the early months of 1861, war was in the offing, and Strong Vincent stood ready for it. Upon returning from Harvard in 1859, Vincent had joined the Wayne Guards, the Erie militia company that had organized that year and that was overseen by the sheriff of the county, Captain John W. McLane, a veteran of the Mexican–American War. As events continued apace through February and March 1861, Captain McLane had his militiamen drilling and preparing for the coming conflict."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn3",
      "id": "rch2fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The war began with the firing on and surrender of Fort Sumter: a 34-hour artillery duel between Confederate shore batteries and the Federal fort beginning on April 12, 1861. On April 15, Abraham Lincoln issued "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("a call for 75,000 volunteers to “suppress said combinations [the Confederacy], and to cause the laws to be duly executed.” Just below Lincoln’s proclamation in the columns of "), _c('em', [_vm._v("The Erie Weekly Gazette")]), _vm._v(" on April 18, 1861, John McLane issued a call to arms, summoning the men of Erie County to rally to their flag and their country. McLane had been commissioned a colonel in the Pennsylvania State Militia by Governor Andrew Curtin, and his call of muster was set for April 21. In response to his summons, 1,200 young men descended upon Erie to enlist in McLane’s regiment. Among them were two young men who would, in later years, become two more of the four principal sources for any examination of Strong Vincent’s military career. Amos M. Judson, a Yale graduate, lawyer, and editor of the "), _c('em', [_vm._v("Waterford Enquirer")]), _vm._v(" was among the enthusiastic volunteers of what became Company E of McLane’s regiment; while Oliver Willcox Norton, the son of a Presbyterian minister and himself a schoolmaster in Springfield Township, was among the scrum of enlistees that became "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Company G of the same regiment. Judson would go onto publish the official regimental history in 1865, and Norton spent the last 30 years of his life doggedly defending the reputation of Strong Vincent."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn4",
      "id": "rch2fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0011-01.jpg",
      "width": "60%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Colonel John W. McLane, commander of the Erie Regiment and of the 83rd Pennsylvania, in uniform as a colonel of the United States Army, circa 1861. ("), _c('em', [_vm._v("Courtesy of the Captain John M. Sell Civil War Collection, California State University Northridge Library")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vincent was named as second lieutenant of Company A by Colonel McLane, serving under company commander Captain Thomas Austin, the owner of a watch and jewelry store in Erie. The regiment set itself up in “Camp Wayne,” a vacant lot on Sixth Street at the intersection of what had been known since Erie’s founding as Parade Street due to its footing at the bayfront on the site of the 18th-century French Fort De La Presqu’ Ile. There, they began to drill and train for war. The men received their “Union Blue” uniforms at Camp Wayne, as within days of its swearing into state service on April 27, the citizens of Erie County raised $17,000 to equip the regiment. Orders from Governor Curtin directed the regiment to Camp Wilkins in Pittsburgh to be sworn into Federal service—but Strong Vincent had one final piece of business to attend to before heading off to war."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn5",
      "id": "rch2fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vincent had never ceased his communications with Elizabeth Carter, who still worked as a teacher at Miss Porter’s School. Now, in mid-April, 1861, he sent her a telegram informing her of his decision to join the fight—and requesting that they be married as quickly as possible. Elizabeth agreed, and Vincent took leave of the Erie Regiment to rush to Jersey City, New Jersey, where they wed at the Dutch Reformed Church on April 25. The newlyweds, unwilling to be separated quite yet, traveled together to Pittsburgh, where the new Mrs. Vincent resided in a hotel near Camp Wilkins. News of their wedding ran in the May 1, 1861, edition of "), _c('em', [_vm._v("The Erie Weekly Gazette")]), _vm._v(", whose staff reported happily, “Our young friend having previously enlisted, is now ‘off to the wars’ … We trust he may safely return to his fair bride after filling the demands of his country upon his services, and thereafter enjoy long continued and uninterrupted domestic felicity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn6",
      "id": "rch2fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The “Erie Regiment” departed for Pittsburgh on May 1, 1861, and even the miserable weather could not dampen the men’s enthusiasm. Amos Judson would recall that their departure occurred “in the midst of a drenching rain,” as “headed by our band, we marched up State street to the depot where we took the cars for Pittsburg amidst the roar "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("of artillery, the waving of handkerchiefs and the tears and prayers of our friends for a safe return.” That same day, Colonel McLane presided over the election of officers, which saw Strong Vincent elevated to first lieutenant of Company A. McLane also selected Vincent to serve as the regimental adjutant—perhaps because of his family’s good name, perhaps because of his competence in his short tenure as second lieutenant, but no rationale for McLane’s decision has survived. It is likely that Vincent’s time in the Wayne Guards from 1859 to 1861 had played a role in McLane’s thought process: Vincent was very likely to have known to the colonel before his official enlistment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regardless, the young lawyer-turned-soldier was already on the rise in the army dedicated to crushing the rebellion by the beginning of May 1861. The new adjutant met the regiment at the depot on the morning of May 2, having arrived in Pittsburgh before them, and joined the columns as the regiment “marched through several of the principal streets, our band playing and our banners flying … the novelty of the scene, together with our picturesque uniforms and the music of our band attracted crowds of lookers-on who followed us in admiration to our place of rendezvous.” Settling in at Camp Wilkins, which had been established at the Pittsburgh fairgrounds on Penn Street (now Penn Avenue), the soldiers began to take advantage of day passes to experience the largest city that many of them had ever seen."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn7",
      "id": "rch2fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Erie Regiment’s stay at Camp Wilkins proved to be short-lived. The impromptu camp on the fairgrounds had been named as the rallying point for all the volunteer regiments being raised in western Pennsylvania, and swiftly became crowded. Colonel McLane had been named commandant of the camp by Governor Curtin, and McLane took Lieutenant Vincent with him on his staff, making Vincent the adjutant of Camp Wilkins in addition to the Erie Regiment. The men at the camp were subjected to 12-hour days of drills, inspections, parades, and learning the ins and outs of military formation. A newspaperman from Erie, visiting Camp Wilkins in late May, proudly proclaimed that, “If any of the boasting Rebels down South imagine that one of their traitor crew can whip three Northern men, they will experience a terrible disappointment when the Erie boys happen along.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn8",
      "id": "rch2fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("In early June, after six weeks at Camp Wilkins, the Erie Regiment was withdrawn to the new Camp Wright on the banks of the Allegheny River, where muskets were finally distributed and where they would continue their training."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn9",
      "id": "rch2fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the soldiers growing restless on the banks of the Allegheny, Vincent was not making a particularly good impression. Oliver Norton wrote later in life of his first memory of the Lieutenant:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("My first recollection of him is his appearance as adjutant in forming the line of the regiment for its first dress parade. As I stood, a private in the ranks, and heard his command on the right, “To the rear open order, March!” and saw the line officers step to the front in an irregular line and heard him correct their faults, then saw him march to the center, halt, turn on his heel, face the colonel … salute with his sword and report, “Sir, the parade is formed,” I confess my first impression of him was not favorable. I thought him a dude and an upstart."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn10",
      "id": "rch2fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To compound the frustration of the soldiers, the regiment received orders to march no fewer than four times during the month of "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("June—to Washington, Chambersburg, Harrisburg, and Harper’s Ferry respectively—yet each time, the orders were almost immediately countermanded. “It began to grow apparent to every one,” wrote Judson, “that we were never destined to see any active service.” Further increasing the frustration of the men was the stark fact that they had not been paid once—even after two months of enlistment—and had never been sworn into Federal service. The discontentment of the soldiers grew so apparent with “the rare spectacle, so seldom witnessed now-a-days, of a regiment spoiling for a fight,” that Colonel McLane saw fit to summon the regiment into the drill square one July morning. The temperature was already in excess of 100-degrees Fahrenheit, but McLane delivered a speech to the men regarding his continued determination to serve the state even if he must “make a free and voluntary gift of his services to her,” and then put his regiment through “three hours of the most animated and perspiring drill that we have ever had.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn11",
      "id": "rch2fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg",
      "width": "60%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Private Oliver Willcox Norton in a tintype photograph in the uniform of the “Girard Guards” militia company, circa 1861. ("), _c('em', [_vm._v("Courtesy of the Theodore Karle Civil War Collection, Erie County Historical Society/Hagen History Center, Erie, Pennsylvania")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not only the men who were growing discontented. Even the energetic and martial Colonel McLane was chafing at being stuck at Pittsburgh. He traveled to the War Department in Washington and demanded that Secretary of War Simon Cameron tell him when his troops would be sworn into Federal service. The Army of Northeastern Virginia, under the command of Major General Irvin McDowell, was gathering at the capital—preparing to march “on to Richmond,” as newspaper headlines declared across the nation—and McLane worried that he and his men would miss the opportunity to participate in the crushing of the Rebellion. President Lincoln’s May 3 proclamation calling for 42,000 men to serve three-year terms of service had overshadowed the summons of the 90-days men; McLane was informed that his regiment would be federalized if, and only if, the men would, on the spot, sign three-year enlistment papers. Returning to Camp Wright, McLane presented the proposal to his men, but most of them scoffed at the three-year terms of service. The war would, they all knew, be over before the end of the year. Why should they enlist for three? The regiment voted to remain together as one unit to serve its 90-day term of service, and thus foiled Governor Curtin’s planned federalization of the regiment."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn12",
      "id": "rch2fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0016-01.jpg",
      "width": "60%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Amos M. Judson, in the uniform of a lieutenant of the 83rd Pennsylvania in March 1862. ("), _c('em', [_vm._v("Courtesy of the Theodore Karle Civil War Collection, Erie County Historical Society/Hagen History Center, Erie, Pennsylvania")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the refusal of the regiment to split into two factions—those who would enlist for three-year terms and those who would not—the unit was released from camp, and returned to Erie on July 20, 1861, where they were welcomed home with a picnic in the city’s Central Park."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/09_chapter_02#ast4",
      "id": "rast4"
    }
  }, [_vm._v("*")])]), _vm._v(" Colonel McLane made a brief speech informing his men that they were to serve the rest of their terms of service—until August 1—on furlough at their homes. The men indulged the hospitality of the city, enjoying the great picnic prepared for them. Judson later recalled their welcome home in his regimental history. “Although we had seen no active service and had not returned covered with the laurels of war, … the people of Erie received us with all the honors that are usually awarded to the heroes of a hundred battlefields.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn13",
      "id": "rch2fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("The very next day, after member of the Erie Regiment picnicked in the park and were turned loose to spend the rest of their enlistments on furlough, the Confederates routed McDowell’s Army of Northeastern Virginia at the battle of Bull Run. As the stunned and terrified army straggled back into Washington City under a driving rain on July 22, panic seized the capital that the victorious Confederates were about to fall upon the city. Even President Lincoln was compelled to admit to a congressman that the situation was “damned bad.” John McLane received a telegram from the War Department on July 24 naming him a colonel in the United States volunteers and commanding him to raise a new regiment. The war would not pass Erie by after all."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#ch2fn14",
      "id": "rch2fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('span', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter_02#rast4",
      "id": "ast4"
    }
  }, [_vm._v("*")])]), _vm._v(" Today known as “Perry Square” for Commodore Oliver Hazard Perry, who raised his Lake Erie fleet in the city in 1813 prior to his victory over the British in the battle of Lake Erie.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ed3ab0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_chapter_02.vue
// module id = 90
// module chunks = 0